import React from "react";
import Noti from "../../../util/noti";

import SiteCreationChild from "./SiteCreationChild";
import AccountingTable from "./AccountingTable";

function SiteCreationInvoicingInfoTable() {
	return (
		<SiteCreationChild requiredRoles={['administration:SiteCreation:_view']}>
			<AccountingTable />
			<Noti />
		</SiteCreationChild>
	);
}

export default SiteCreationInvoicingInfoTable;
